import Icon from 'veui/components/Icon'
import { IconReportCheck } from 'dls-icons-vue'

Icon.register('report-check', IconReportCheck)
